import { HOSPITAL_BILLING_PATIENT } from '../routes/urls';

export function generateBillingUrl(uuidPatient: string): string {
  return HOSPITAL_BILLING_PATIENT.replace(':uuidPatient', uuidPatient);
} 